export class InputDialogContent {
    message: string;
    inputName: string;
    inputContent: string;
    title: string = null;
    inputType = 'text';
}
